import React, { useState } from "react";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useField, ErrorMessage } from "formik";
import PropTypes from "prop-types";
import FormikLabel from "./FormikLabel";
import { ErrorStyle } from "./ErrorStyle";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const FormikPasswordInput = ({
  name = "",
  label = "",
  width = "100%",
  required = false,
  placeholder = "",
  disabled = false,
  onChange = () => {},
  ...props
}) => {
  const [field, meta, helpers] = useField(name);
  const [showPassword, setShowPassword] = useState(false);
  const handleToggleVisibility = () => setShowPassword((prev) => !prev);

  return (
    <div style={{ marginBottom: "16px", width }}>
      <FormikLabel text={label} required={required} />
      <TextField
        {...field}
        {...props}
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        disabled={disabled}
        fullWidth
        sx={{
          ...props.sx,
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            borderWidth: "1px",
          },
          "& .MuiInputBase-input": {
            padding: "8px",
            backgroundColor: disabled ? "#f5f5f5" : "inherit",
          },
        }}
        onChange={(e) => {
          onChange(e);
          helpers.setValue(e.target.value);
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleToggleVisibility} edge="end">
                {showPassword ? <Visibility /> : <VisibilityOff />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <div style={ErrorStyle}>
        <ErrorMessage name={name} />
      </div>
    </div>
  );
};

// PropTypes for validation
FormikPasswordInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  width: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default FormikPasswordInput;
